import { Col, Label, Row } from "reactstrap";
import { getDateTime } from "../Function/ConvertDate";
import dayjs from "dayjs";
import { GetCookieData } from "../Cookie/GetCookie";


const ApproveHistory = (props) => {
  const user_position = GetCookieData("userPosition");
  const {getUserApprove, user, leaveDataEdit} = props;
  let startDay = new Date(2024, 10, 18, 0, 0, 0);
  let writeDate = new Date(leaveDataEdit?.write_date)
  writeDate = new Date(writeDate.setHours(writeDate.getHours() -7))

  if (writeDate < startDay) {// ระบบเก่า
    return (
      getUserApprove?.map((item, idx, arr) => {
                let checkPosition = (user_position && user_position?.find((a) => a?.position_id >= 2 && a?.position_id <= 7)) || null; 
                  if (checkPosition) {
                    if (idx === 0) {
                      return (
                        <>
                        <h4>ประวัติการอนุมัติ</h4>
                        <Row
                          key={idx}
                          className="mt-2 pb-1"
                          style={{ borderBottom: "1px solid lightgray" }}
                        >
                          <Col>
                            <Row className="d-flex justify-content-center">
                              <Label xxl={4}>
                                {item?.leave_status === null
                                  ? "รอดำเนินการโดย"
                                  : "ดำเนินการโดย"}{" "}
                                : {item?.approve_name}
                              </Label>
                              <Label xxl={4}>
                                วันที่ดำเนินการ :{" "}
                                {item?.approve_date
                                  ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                  : null}
                              </Label>
                            </Row>
                            <Row className="d-flex justify-content-center">
                              <Label xxl={4}>
                                สถานะ :{" "}
                                {(() => {
                                  if (item?.approve_final === '0') {
                                    if (item?.approve_status === '1') {
                                      return 'อนุญาต';
                                    } else {
                                      return 'รอดำเนินการ';
                                    }
                                  } else if (item?.approve_final === '1'){
                                    if (item?.approve_status === '0') {
                                      return 'รอดำเนินการ';
                                    } else if (item?.approve_status === '1') {
                                      return 'อนุมัติ';
                                    } else if (item?.approve_status === '2'){
                                      return 'ไม่อนุมัติ';
                                    }
                                  } else {
                                    return 'ไม่ระบุ'
                                  }
                                })()}
                              </Label>
                              <Label xxl={4}>
                                ความเห็น : {item?.reason || "-"}
                              </Label>
                            </Row>
                          </Col>
                        </Row></>
                      );
                    } else if (idx !== 0) {
                      if (arr[idx - 1]?.leave_status === "5") {
                        return (
                          <>
                            <h4 className="mt-3 ms-2">ประวัติการขอยกเลิก</h4>
                            <Row
                              key={idx}
                              className="mt-2 pb-1"
                              style={{ borderBottom: "1px solid lightgray" }}
                            >
                              <Col>
                                <Row className="d-flex justify-content-center">
                                  <Label xxl={6}>
                                    {item?.leave_status === null
                                      ? "รอดำเนินการโดย"
                                      : "ดำเนินการโดย"}
                                    : {item?.approve_name}
                                  </Label>
                                  <Label xxl={4}>
                                    วันที่ดำเนินการ :{" "}
                                    {item?.approve_date
                                      ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                      : null}
                                  </Label>
                                </Row>
                                <Row className="d-flex justify-content-center">
                                  <Label xxl={4}>
                                    สถานะ :{" "}
                                    {(() => {
                                      if (item?.approve_final === '0') {
                                        if (item?.approve_status === '1') {
                                          return 'อนุญาต';
                                        } else {
                                          return 'รอดำเนินการ';
                                        }
                                      } else if (item?.approve_final === '1'){
                                        if (item?.approve_status === '0') {
                                          return 'รอดำเนินการ';
                                        } else if (item?.approve_status === '1') {
                                          return 'อนุมัติ';
                                        } else if (item?.approve_status === '2'){
                                          return 'ไม่อนุมัติ';
                                        }
                                      } else {
                                        return 'ไม่ระบุ'
                                      }
                                    })()}
                                  </Label>
                                  <Label xxl={4}>
                                    ความเห็น : {item?.reason || "-"}
                                  </Label>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        );
                      }
                      return (
                        <Row
                          key={idx}
                          className="mt-2 pb-1"
                          style={{ borderBottom: "1px solid lightgray" }}
                        >
                          <Col>
                            <Row className="d-flex justify-content-center">
                              <Label xxl={4}>
                                {item?.leave_status === null
                                  ? "รอดำเนินการโดย"
                                  : "ดำเนินการโดย"}
                                : {item?.approve_name}
                              </Label>
                              <Label xxl={4}>
                                วันที่ดำเนินการ :{" "}
                                {item?.approve_date
                                  ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                  : null}
                              </Label>
                            </Row>
                            <Row className="d-flex justify-content-center">
                              <Label xxl={4}>
                                สถานะ :{" "}
                                {(() => {
                                  if (item?.approve_final === '0') {
                                    if (item?.approve_status === '1') {
                                      return 'อนุญาต';
                                    } else {
                                      return 'รอดำเนินการ';
                                    }
                                  } else if (item?.approve_final === '1'){
                                    if (item?.approve_status === '0') {
                                      return 'รอดำเนินการ';
                                    } else if (item?.approve_status === '1') {
                                      return 'อนุมัติ';
                                    } else if (item?.approve_status === '2'){
                                      return 'ไม่อนุมัติ';
                                    }
                                  } else {
                                    return 'ไม่ระบุ'
                                  }
                                })()}
                              </Label>
                              <Label xxl={4}>
                                ความเห็น : {item?.reason || "-"}
                              </Label>
                            </Row>
                          </Col>
                        </Row>
                      );
                    }
                  } else {
                    if (idx === 0) {
                      return (
                        <>
                          <h4 className="ms-2">ประวัติการอนุมัติ</h4>
                          <Row
                            key={idx}
                            className="mt-2 pb-1"
                            style={{ borderBottom: "1px solid lightgray" }}
                          >
                            <Col>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={6}>
                                  {item?.leave_status === null
                                    ? "รอดำเนินการโดย"
                                    : "ดำเนินการโดย"}{" "}
                                  : {item?.approve_name}
                                </Label>
                                <Label xxl={4}>
                                  วันที่ดำเนินการ :{" "}
                                  {item?.approve_date
                                    ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                    : null}
                                </Label>
                              </Row>
                              <Row className="d-flex justify-content-center">
                              <Label xxl={4}>
                                สถานะ :{" "}
                                {(() => {
                                  if (item?.approve_final === '0') {
                                    if (item?.approve_status === '1') {
                                      return 'อนุญาต';
                                    } else {
                                      return 'รอดำเนินการ';
                                    }
                                  } else if (item?.approve_final === '1'){
                                    if (item?.approve_status === '0') {
                                      return 'รอดำเนินการ';
                                    } else if (item?.approve_status === '1') {
                                      return 'อนุมัติ';
                                    } else if (item?.approve_status === '2'){
                                      return 'ไม่อนุมัติ';
                                    }
                                  } else {
                                    return 'ไม่ระบุ'
                                  }
                                })()}
                              </Label>

                                <Label xxl={4}>
                                  ความเห็น : {item?.reason || "-"}
                                </Label>
                              </Row>
                            </Col>
                          </Row>
                        </>
                      );
                    } else if (idx !== 0) {
                      if (arr[idx - 1]?.leave_status === "5") {
                        return (
                          <>
                            <h4 className="mt-3 ms-2">ประวัติการขอยกเลิก</h4>
                            <Row
                              key={idx}
                              className="mt-2 pb-1"
                              style={{ borderBottom: "1px solid lightgray" }}
                            >
                              <Col>
                                <Row className="d-flex justify-content-center">
                                  <Label xxl={6}>
                                    {item?.leave_status === null
                                      ? "รอดำเนินการโดย"
                                      : "ดำเนินการโดย"}
                                    : {item?.approve_name}
                                  </Label>
                                  <Label xxl={4}>
                                    วันที่ดำเนินการ :{" "}
                                    {item?.approve_date
                                      ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                      : null}
                                  </Label>
                                </Row>
                                <Row className="d-flex justify-content-center">
                                  <Label xxl={4}>
                                    สถานะ :{" "}
                                    {item?.approve_status === '1' ? (item?.approve_final === '1' ? 'อนุญาตยกเลิก' : 'รอดำเนินการ') : '' }
                                  </Label>
                                  <Label xxl={4}>
                                    ความเห็น : {item?.reason || "-"}
                                  </Label>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        );
                      }
                      return (
                        <Row
                          key={idx}
                          className="mt-2 pb-1"
                          style={{ borderBottom: "1px solid lightgray" }}
                        >
                          <Col>
                            <Row className="d-flex justify-content-center">
                              <Label xxl={6}>
                                {item?.leave_status === null
                                  ? "รอดำเนินการโดย"
                                  : "ดำเนินการโดย"}
                                : {item?.approve_name}
                              </Label>
                              <Label xxl={4}>
                                วันที่ดำเนินการ :{" "}
                                {item?.approve_date
                                  ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                  : null}
                              </Label>
                            </Row>
                            <Row className="d-flex justify-content-center">
                              <Label xxl={4}>
                                สถานะ :{" "}
                                {(() => {
                                  if (item?.approve_final === '0') {
                                    if (item?.approve_status === '1') {
                                      return 'อนุญาต';
                                    } else {
                                      return 'รอดำเนินการ';
                                    }
                                  } else if (item?.approve_final === '1'){
                                    if (item?.approve_status === '0') {
                                      return 'รอดำเนินการ';
                                    } else if (item?.approve_status === '1') {
                                      return 'อนุมัติ';
                                    } else if (item?.approve_status === '2'){
                                      return 'ไม่อนุมัติ';
                                    }
                                  } else {
                                    return 'ไม่ระบุ'
                                  }
                                })()}
                              </Label>
                              <Label xxl={4}>
                                ความเห็น : {item?.reason || "-"}
                              </Label>
                            </Row>
                          </Col>
                        </Row>
                      );
                    }
                  }
              })
  )
  } else {
    return (
        getUserApprove?.map((item, idx, arr) => {
                  // console.log(idx, item);
                  let checkPosition = (user_position && user_position?.find((a) => a?.position_id >= 2 && a?.position_id <= 7)) || null;
                    // console.log({index: idx, leaveStatus: item?.leave_status, prevLeaveStatus : arr[idx-1]?.leave_status, checkPosition : checkPosition});
                  if (
                    leaveDataEdit?.form_type === 1 ||
                    leaveDataEdit?.form_type === 2 ||
                    leaveDataEdit?.form_type === 9 ||
                    leaveDataEdit?.form_type === 10 ||
                    leaveDataEdit?.form_type === 12
                  ) {
                    if (checkPosition) {
                      if (idx === 0) {
                        return (
                          <>
                          <h4>ประวัติการอนุมัติ</h4>
                          {/* {item?.approve_date && dayjs(item?.approve_date).locale('th').format('MMMM BBBB')} */}
                          <Row
                            key={idx}
                            className="mt-2 pb-1"
                            style={{ borderBottom: "1px solid lightgray" }}
                          >
                            <Col>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={4}>
                                  {item?.leave_status === null
                                    ? "รอดำเนินการโดย"
                                    : "ดำเนินการโดย"}{" "}
                                  : {item?.approve_name}
                                </Label>
                                <Label xxl={4}>
                                  วันที่ดำเนินการ :{" "}
                                  {item?.approve_date
                                    ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                    : null}
                                </Label>
                              </Row>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={4}>
                                  สถานะ :{" "}
                                  {item?.leave_status === null
                                    ? "รอดำเนินการ"
                                    //"รออนุมัติ"
                                    : item?.leave_status === "3"
                                    ? "อนุญาต"
                                    : item?.leave_status === "5"
                                    ? "อนุมัติ"
                                    : item?.leave_status === "6"
                                    ? !arr[idx - 1]?.leave_status ? "ไม่อนุมัติ" : "ไม่อนุญาต"
                                    : item?.leave_status === "9"
                                    ? "ส่งกลับแก้ไข"
                                    : item?.leave_status === "M"
                                    ? "-"
                                    : "ยกเลิก"}
                                </Label>
                                <Label xxl={4}>
                                  ความเห็น : {item?.reason || "-"}
                                </Label>
                              </Row>
                            </Col>
                          </Row></>
                        );
                      } else if (idx !== 0) {
                        if (arr[idx - 1]?.leave_status === "5") {
                          return (
                            <>
                              <h4 className="mt-3 ms-2">ประวัติการขอยกเลิก</h4>
                              <Row
                                key={idx}
                                className="mt-2 pb-1"
                                style={{ borderBottom: "1px solid lightgray" }}
                              >
                                <Col>
                                  <Row className="d-flex justify-content-center">
                                    <Label xxl={6}>
                                      {item?.leave_status === null
                                        ? "รอดำเนินการโดย"
                                        : "ดำเนินการโดย"}
                                      : {item?.approve_name}
                                    </Label>
                                    <Label xxl={4}>
                                      วันที่ดำเนินการ :{" "}
                                      {item?.approve_date
                                        ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                        : null}
                                    </Label>
                                  </Row>
                                  <Row className="d-flex justify-content-center">
                                    <Label xxl={4}>
                                      สถานะ :{" "}
                                      {item?.leave_status === null
                                        ? arr[idx - 1]?.leave_status === "3"
                                          ? "รอดำเนินการ"
                                          // "รออนุมัติ"
                                          : arr[idx - 1]?.leave_status === "5"
                                          ? "รอดำเนินการ"
                                          // "รออนุญาตยกเลิก"
                                          : arr[idx - 1]?.leave_status === "B"
                                          ? "รอดำเนินการ"
                                          : arr[idx - 1]?.leave_status === "M"
                                          ? "-"
                                          // "รออนุมัติยกเลิก"
                                          : "ยกเลิก"
                                        : item?.leave_status === "3"
                                        ? "อนุญาตยกเลิก"
                                        : item?.leave_status === "5"
                                        ? arr[idx - 1]?.leave_status === "5" || arr[idx - 1]?.leave_status === "B"
                                        ? "ไม่อนุมัติยกเลิก" : "อนุมัติ"
                                        : item?.leave_status === "6"
                                        ? "ไม่อนุมัติ"
                                        : item?.leave_status === "B"
                                        ? "อนุญาตยกเลิก"
                                        : item?.leave_status === "A"
                                        ? "อนุมัติยกเลิก"
                                        : item?.leave_status === "M"
                                        ? "-"
                                        : null}
                                    </Label>
                                    <Label xxl={4}>
                                      ความเห็น : {item?.reason || "-"}
                                    </Label>
                                  </Row>
                                </Col>
                              </Row>
                            </>
                          );
                        }
                        return (
                          <Row
                            key={idx}
                            className="mt-2 pb-1"
                            style={{ borderBottom: "1px solid lightgray" }}
                          >
                            <Col>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={4}>
                                  {item?.leave_status === null
                                    ? "รอดำเนินการโดย"
                                    : "ดำเนินการโดย"}
                                  : {item?.approve_name}
                                </Label>
                                <Label xxl={4}>
                                  วันที่ดำเนินการ :{" "}
                                  {item?.approve_date
                                    ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                    : null}
                                </Label>
                              </Row>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={4}>
                                  สถานะ :{" "}
                                  {item?.leave_status === null
                                    ? arr[idx - 1]?.leave_status === "5"
                                      ? "รอดำเนินการ"
                                      //"รออนุมัติยกเลิก"
                                      : arr[idx - 1]?.leave_status === "7"
                                      ? "รอดำเนินการ"
                                      : arr[idx - 1]?.leave_status === "9"
                                      ? "รอดำเนินการ"
                                      : arr[idx - 1]?.leave_status === "3"
                                      ? "รอดำเนินการ"
                                        // "รออนุมัติยกเลิก"
                                      : "ยกเลิก"
                                    : item?.leave_status === "3"
                                    ? "อนุญาต"
                                    : item?.leave_status === "5"
                                    ? "อนุมัติ"
                                    : item?.leave_status === "5"
                                    ? "อนุมัติ"
                                    : item?.leave_status === "6"
                                    ? "ไม่อนุมัติ"
                                    : item?.leave_status === "9"
                                    ? "ส่งกลับแก้ไข"
                                    : item?.leave_status === "B"
                                    ? "อนุญาตยกเลิก"
                                    : item?.leave_status === "A"
                                    ? "อนุมัติยกเลิก"
                                    : null}
                                </Label>
                                <Label xxl={4}>
                                  ความเห็น : {item?.reason || "-"}
                                </Label>
                              </Row>
                            </Col>
                          </Row>
                        );
                      }
                    } else {
                      if (idx === 0) {
                        return (
                          <>
                            <h4 className="ms-2">ประวัติการอนุมัติ</h4>
                            <Row
                              key={idx}
                              className="mt-2 pb-1"
                              style={{ borderBottom: "1px solid lightgray" }}
                            >
                              <Col>
                                <Row className="d-flex justify-content-center">
                                  <Label xxl={6}>
                                    {item?.leave_status === null
                                      ? "รอดำเนินการโดย"
                                      : "ดำเนินการโดย"}{" "}
                                    : {item?.approve_name}
                                  </Label>
                                  <Label xxl={4}>
                                    วันที่ดำเนินการ :{" "}
                                    {item?.approve_date
                                      ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                      : null}
                                  </Label>
                                </Row>
                                <Row className="d-flex justify-content-center">
                                  <Label xxl={4}>
                                    สถานะ :{" "}
                                    {item?.leave_status === null
                                      ? "รอดำเนินการ"
                                      // "รออนุญาต"
                                      : item?.leave_status === "3"
                                      ? "อนุญาต"
                                      : item?.leave_status === "5"
                                      ? "อนุมัติ"
                                      : item?.leave_status === "6"
                                      ? "ไม่อนุญาต"
                                      : item?.leave_status === "9"
                                      ? "ส่งกลับแก้ไข"
                                      : item?.leave_status === "M"
                                      ? "-"
                                      : "ยกเลิก"}
                                  </Label>
                                  <Label xxl={4}>
                                    ความเห็น : {item?.reason || "-"}
                                  </Label>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        );
                      } else if (idx !== 0) {
                        if (arr[idx - 1]?.leave_status === "5") {
                          return (
                            <>
                              <h4 className="mt-3 ms-2">ประวัติการขอยกเลิก</h4>
                              <Row
                                key={idx}
                                className="mt-2 pb-1"
                                style={{ borderBottom: "1px solid lightgray" }}
                              >
                                <Col>
                                  <Row className="d-flex justify-content-center">
                                    <Label xxl={6}>
                                      {item?.leave_status === null
                                        ? "รอดำเนินการโดย"
                                        : "ดำเนินการโดย"}
                                      : {item?.approve_name}
                                    </Label>
                                    <Label xxl={4}>
                                      วันที่ดำเนินการ :{" "}
                                      {item?.approve_date
                                        ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                        : null}
                                    </Label>
                                  </Row>
                                  <Row className="d-flex justify-content-center">
                                    <Label xxl={4}>
                                      สถานะ :{" "}
                                      {item?.leave_status === null
                                        ? arr[idx - 1]?.leave_status === "3"
                                          ? "รอดำเนินการ"
                                          // "รออนุมัติ"
                                          : arr[idx - 1]?.leave_status === "5"
                                          ? "รอดำเนินการ"
                                          // "รออนุญาตยกเลิก"
                                          : arr[idx - 1]?.leave_status === "B"
                                          ? "รอดำเนินการ"
                                          : arr[idx - 1]?.leave_status === "M"
                                          ? "-"
                                          // "รออนุมัติยกเลิก"
                                          : "ยกเลิก"
                                        : item?.leave_status === "3"
                                        ? "อนุญาตยกเลิก"
                                        : item?.leave_status === "5"
                                        ? arr[idx - 1]?.leave_status === "5" || arr[idx - 1]?.leave_status === "B"
                                        ? "ไม่อนุมัติยกเลิก" : "อนุมัติ"
                                        : item?.leave_status === "6"
                                        ? "ไม่อนุมัติ"
                                        : item?.leave_status === "B"
                                        ? "อนุญาตยกเลิก"
                                        : item?.leave_status === "A"
                                        ? "อนุมัติยกเลิก"
                                        : item?.leave_status === "M"
                                        ? "-"
                                        : null}
                                    </Label>
                                    <Label xxl={4}>
                                      ความเห็น : {item?.reason || "-"}
                                    </Label>
                                  </Row>
                                </Col>
                              </Row>
                            </>
                          );
                        }
                        return (
                          <Row
                            key={idx}
                            className="mt-2 pb-1"
                            style={{ borderBottom: "1px solid lightgray" }}
                          >
                            <Col>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={6}>
                                  {item?.leave_status === null
                                    ? "รอดำเนินการโดย"
                                    : "ดำเนินการโดย"}
                                  : {item?.approve_name}
                                </Label>
                                <Label xxl={4}>
                                  วันที่ดำเนินการ :{" "}
                                  {item?.approve_date
                                    ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                    : null}
                                </Label>
                              </Row>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={4}>
                                  สถานะ :{" "}
                                  {item?.leave_status === null
                                    ? arr[idx - 1]?.leave_status === "3"
                                      ? "รอดำเนินการ"
                                      // "รออนุมัติ"
                                      : arr[idx - 1]?.leave_status === "5"
                                      ? "รอดำเนินการ"
                                      // "รออนุญาตยกเลิก"
                                      : arr[idx - 1]?.leave_status === "B"
                                      ? "รอดำเนินการ"
                                      // "รออนุมัติยกเลิก"
                                      : arr[idx - 1]?.leave_status === "9"
                                      ? "รอดำเนินการ"
                                      : arr[idx - 1]?.leave_status === "M"
                                      ? "-"
                                      // "รออนุญาต"
                                      : "ยกเลิก"
                                    : item?.leave_status === "3"
                                    ? arr[idx - 1]?.leave_status === "9" || arr[idx - 1]?.leave_status === "3"
                                    ? "อนุญาต" : "ไม่ระบุ"
                                    : item?.leave_status === "5" ? arr[idx - 1]?.leave_status === "5" || arr[idx - 1]?.leave_status === "B"
                                    ? "ไม่อนุมัติยกเลิก"
                                    : "อนุมัติ"
                                    : item?.leave_status === "6"
                                    ? "ไม่อนุมัติ"
                                    : item?.leave_status === "9"
                                    ? "ส่งกลับแก้ไข"
                                    : item?.leave_status === "B"
                                    ? "อนุญาตยกเลิก"
                                    : item?.leave_status === "A"
                                    ? "อนุมัติยกเลิก"
                                    : item?.leave_status === "M"
                                    ? "-"
                                    : null}
                                </Label>
                                <Label xxl={4}>
                                  ความเห็น : {item?.reason || "-"}
                                </Label>
                              </Row>
                            </Col>
                          </Row>
                        );
                      }
                    }
                  } 
                  // 4 ขั้น
                    else if (
                    leaveDataEdit?.form_type === 3 ||
                    leaveDataEdit?.form_type === 4 ||
                    leaveDataEdit?.form_type === 5
                  ) {
                    if (checkPosition) {
                      if (idx === 0) {
                        return (
                          <>
                          <h4>ประวัติการอนุมัติ</h4>
                          <Row
                            key={idx}
                            className="mt-2 pb-1"
                            style={{ borderBottom: "1px solid lightgray" }}
                          >
                            <Col>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={6}>
                                  {item?.leave_status === null
                                    ? "รอดำเนินการโดย"
                                    : "ดำเนินการโดย"}{" "}
                                  : {item?.approve_name}
                                </Label>
                                <Label xxl={4}>
                                  วันที่ดำเนินการ :{" "}
                                  {item?.approve_date
                                    ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                    : null}
                                </Label>
                              </Row>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={4}>
                                  สถานะ :{" "}
                                  {item?.leave_status === null
                                    ? "รอดำเนินการ"
                                    // "รออนุมัติ"
                                    : item?.leave_status === "3"
                                    ? "อนุญาต"
                                    : item?.leave_status === "5"
                                    ? "อนุมัติ"
                                    : item?.leave_status === "6"
                                    ? !arr[idx - 1]?.leave_status ? "ไม่อนุมัติ" : "ไม่อนุญาต"
                                    : item?.leave_status === "9"
                                    ? "ส่งกลับแก้ไข"
                                    : item?.leave_status === "M"
                                    ? "-"
                                    : "ยกเลิก"}
                                </Label>
                                <Label xxl={4}>
                                  ความเห็น : {item?.reason || "-"}
                                </Label>
                              </Row>
                            </Col>
                          </Row></>
                        );
                      } else if (idx !== 0) {
                        if (arr[idx - 1]?.leave_status === "5") {
                          return (
                            <>
                              <h4 className="mt-3 ms-2">ประวัติการขอยกเลิก</h4>
                              <Row
                                key={idx}
                                className="mt-2 pb-1"
                                style={{ borderBottom: "1px solid lightgray" }}
                              >
                                <Col>
                                  <Row className="d-flex justify-content-center">
                                    <Label xxl={6}>
                                      {item?.leave_status === null
                                        ? "รอดำเนินการโดย"
                                        : "ดำเนินการโดย"}
                                      : {item?.approve_name}
                                    </Label>
                                    <Label xxl={4}>
                                      วันที่ดำเนินการ :{" "}
                                      {item?.approve_date
                                        ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                        : null}
                                    </Label>
                                  </Row>
                                  <Row className="d-flex justify-content-center">
                                    <Label xxl={4}>
                                      สถานะ :{" "}
                                      {item?.leave_status === null
                                        ? arr[idx - 1]?.leave_status === "3"
                                          ? "รอดำเนินการ"
                                          // "รออนุมัติ"
                                          : arr[idx - 1]?.leave_status === "5"
                                          ? "รอดำเนินการ"
                                          // "รออนุญาตยกเลิก"
                                          : arr[idx - 1]?.leave_status === "B"
                                          ? "รอดำเนินการ"
                                          : arr[idx - 1]?.leave_status === "M"
                                          ? "-"
                                          // "รออนุมัติยกเลิก"
                                          : "ยกเลิก"
                                        : item?.leave_status === "3"
                                        ? "อนุญาตยกเลิก"
                                        : item?.leave_status === "5"
                                        ? arr[idx - 1]?.leave_status === "5" || arr[idx - 1]?.leave_status === "B"
                                        ? "ไม่อนุมัติยกเลิก" : "อนุมัติ"
                                        : item?.leave_status === "6"
                                        ? "ไม่อนุมัติ"
                                        : item?.leave_status === "B"
                                        ? "อนุญาตยกเลิก"
                                        : item?.leave_status === "A"
                                        ? "อนุมัติยกเลิก"
                                        : item?.leave_status === "M"
                                        ? "-"
                                        : null}
                                    </Label>
                                    <Label xxl={4}>
                                      ความเห็น : {item?.reason || "-"}
                                    </Label>
                                  </Row>
                                </Col>
                              </Row>
                            </>
                          );
                        }
                        return (
                          <>
                            {/* <h4>ประวัติการอนุมัติ</h4> */}
                            <Row
                              key={idx}
                              className="mt-2 pb-1"
                              style={{ borderBottom: "1px solid lightgray" }}
                            >
                              <Col>
                                <Row className="d-flex justify-content-center">
                                  <Label xxl={6}>
                                    {item?.leave_status === null
                                      ? "รอดำเนินการโดย"
                                      : "ดำเนินการโดย"}
                                    : {item?.approve_name}
                                  </Label>
                                  <Label xxl={4}>
                                    วันที่ดำเนินการ :{" "}
                                    {item?.approve_date
                                      ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                      : null}
                                  </Label>
                                </Row>
                                <Row className="d-flex justify-content-center">
                                  <Label xxl={4}>
                                    สถานะ :{" "}
                                    {item?.leave_status === null
                                      ? arr[idx - 1]?.leave_status === "5"
                                        ? "รอดำเนินการ"
                                        // "รออนุมัติยกเลิก"
                                        : arr[idx - 1]?.leave_status === "7"
                                        ? "รอดำเนินการ"
                                        : arr[idx - 1]?.leave_status === "3"
                                        ? "รอดำเนินการ"
                                        : arr[idx - 1]?.leave_status === "9"
                                        ? "รอดำเนินการ"
                                        : arr[idx - 1]?.leave_status === "M"
                                        ? "-"
                                        // "รออนุมัติยกเลิก"
                                        : "ยกเลิก"
                                      : item?.leave_status === "5"
                                      ? arr[idx - 1]?.leave_status === "5" || arr[idx - 1]?.leave_status === "B"
                                        ? "ไม่อนุมัติยกเลิก" : "อนุมัติ"
                                      : item?.leave_status === "6"
                                      ? "ไม่อนุมัติ"
                                      : item?.leave_status === "B"
                                      ? "อนุญาตยกเลิก"
                                      : item?.leave_status === "A"
                                      ? "อนุมัติยกเลิก"
                                      : item?.leave_status === "3"
                                      ? "อนุญาต"
                                      : item?.leave_status === "9"
                                      ? "ส่งกลับแก้ไข"
                                      : item?.leave_status === "M"
                                      ? "-"
                                      : null}
                                  </Label>
                                  <Label xxl={4}>
                                    ความเห็น : {item?.reason || "-"}
                                  </Label>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        );
                      }
                    } else {
                      if (idx === 0) {
                        return (
                          <>
                            <h4>ประวัติการอนุมัติ</h4>
                            <Row
                              key={idx}
                              className="mt-2 pb-1"
                              style={{ borderBottom: "1px solid lightgray" }}
                            >
                              <Col>
                                <Row className="d-flex justify-content-center">
                                  <Label xxl={6}>
                                    {item?.leave_status === null
                                      ? "รอดำเนินการโดย"
                                      : "ดำเนินการโดย"}{" "}
                                    : {item?.approve_name}
                                  </Label>
                                  <Label xxl={4}>
                                    วันที่ดำเนินการ :{" "}
                                    {item?.approve_date
                                      ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                      : null}
                                  </Label>
                                </Row>
                                <Row className="d-flex justify-content-center">
                                  <Label xxl={4}>
                                    สถานะ :{" "}
                                    {item?.leave_status === null
                                      ? "รอดำเนินการ"
                                      // "รออนุญาต"
                                      : item?.leave_status === "3"
                                      ? "อนุญาต"
                                      : item?.leave_status === "6"
                                      ? "ไม่อนุญาต"
                                      : item?.leave_status === "9"
                                      ? "ส่งกลับแก้ไข"
                                      : item?.leave_status === "M"
                                      ? "-"
                                      : "ยกเลิก"}
                                  </Label>
                                  <Label xxl={4}>
                                    ความเห็น : {item?.reason || "-"}
                                  </Label>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        );
                      } else if (idx !== 0) {
                        if (arr[idx - 1]?.leave_status === "5") {
                          return (
                            <>
                              <h4 className="mt-3 ms-2">ประวัติการขอยกเลิก</h4>
                              <Row
                                key={idx}
                                className="mt-2 pb-1"
                                style={{ borderBottom: "1px solid lightgray" }}
                              >
                                <Col>
                                  <Row className="d-flex justify-content-center">
                                    <Label xxl={6}>
                                      {item?.leave_status === null
                                        ? "รอดำเนินการโดย"
                                        : "ดำเนินการโดย"}
                                      : {item?.approve_name}
                                    </Label>
                                    <Label xxl={4}>
                                      วันที่ดำเนินการ :{" "}
                                      {item?.approve_date
                                        ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                        : null}
                                    </Label>
                                  </Row>
                                  <Row className="d-flex justify-content-center">
                                    <Label xxl={4}>
                                      สถานะ :{" "}
                                      {item?.leave_status === null
                                        ? arr[idx - 1]?.leave_status === "3"
                                          ? "รอดำเนินการ"
                                          // "รออนุมัติ"
                                          : arr[idx - 1]?.leave_status === "5"
                                          ? "รอดำเนินการ"
                                          // "รออนุญาตยกเลิก"
                                          : arr[idx - 1]?.leave_status === "B"
                                          ? "รอดำเนินการ"
                                          : arr[idx - 1]?.leave_status === "M"
                                          ? "-"
                                          // "รออนุมัติยกเลิก"
                                          : "ยกเลิก"
                                        : item?.leave_status === "3"
                                        ? "อนุญาตยกเลิก"
                                        : item?.leave_status === "5"
                                        ? arr[idx - 1]?.leave_status === "5" || arr[idx - 1]?.leave_status === "B"
                                        ? "ไม่อนุมัติยกเลิก" : "อนุมัติ"
                                        : item?.leave_status === "6"
                                        ? "ไม่อนุมัติ"
                                        : item?.leave_status === "B"
                                        ? "อนุญาตยกเลิก"
                                        : item?.leave_status === "A"
                                        ? "อนุมัติยกเลิก"
                                        : item?.leave_status === "M"
                                        ? "-"
                                        : null}
                                    </Label>
                                    <Label xxl={4}>
                                      ความเห็น : {item?.reason || "-"}
                                    </Label>
                                  </Row>
                                </Col>
                              </Row>
                            </>
                          );
                        }
                        return (
                          <>
                            {/* <h4>ประวัติการอนุมัติ</h4> */}
                            <Row
                              key={idx}
                              className="mt-2 pb-1"
                              style={{ borderBottom: "1px solid lightgray" }}
                            >
                              <Col>
                                <Row className="d-flex justify-content-center">
                                  <Label xxl={6}>
                                    {item?.leave_status === null
                                      ? "รอดำเนินการโดย"
                                      : "ดำเนินการโดย"}
                                    : {item?.approve_name}
                                  </Label>
                                  <Label xxl={4}>
                                    วันที่ดำเนินการ :{" "}
                                    {item?.approve_date
                                      ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                      : null}
                                  </Label>
                                </Row>
                                <Row className="d-flex justify-content-center">
                                  <Label xxl={4}>
                                    สถานะ :{" "}
                                    {item?.leave_status === null
                                      ? arr[idx - 1]?.leave_status === "3"
                                        ? "รอดำเนินการ"
                                        //"รออนุมัติ"
                                        : arr[idx - 1]?.leave_status === "5"
                                        ? "รอดำเนินการ"
                                        // "รออนุญาตยกเลิก"
                                        : arr[idx - 1]?.leave_status === "B"
                                        ? "รอดำเนินการ"
                                        : arr[idx - 1]?.leave_status === "M"
                                        ? "-"
                                        // "รออนุมัติยกเลิก"
                                        : "ยกเลิก"
                                      : item?.leave_status === "5"
                                      ? arr[idx - 1]?.leave_status === "5" || arr[idx - 1]?.leave_status === "B"
                                        ? "ไม่อนุมัติยกเลิก" : "อนุมัติ"
                                      : item?.leave_status === "6"
                                      ? "ไม่อนุมัติ"
                                      : item?.leave_status === "B"
                                      ? "อนุญาตยกเลิก"
                                      : item?.leave_status === "A"
                                      ? "อนุมัติยกเลิก"
                                      : item?.leave_status === "3"
                                      ? "อนุญาต"
                                      : item?.leave_status === "9"
                                      ? "ส่งกลับแก้ไข"
                                      : item?.leave_status === "M"
                                      ? "-"
                                      : null}
                                  </Label>
                                  <Label xxl={4}>
                                    ความเห็น : {item?.reason || "-"}
                                  </Label>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        );
                      }
                    }
                  } else if (
                    leaveDataEdit?.form_type === 6 ||
                    leaveDataEdit?.form_type === 7 ||
                    leaveDataEdit?.form_type === 8 ||
                    leaveDataEdit?.form_type === 11
                  ) {
                    if (checkPosition) {
                      if (idx === 0) {
                        return (
                          <>
                          <h4>ประวัติการอนุมัติ</h4>
                          <Row
                            key={idx}
                            className="mt-2 pb-1"
                            style={{ borderBottom: "1px solid lightgray" }}
                          >
                            <Col>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={6}>
                                  {item?.leave_status === null
                                    ? "รอดำเนินการโดย"
                                    : "ดำเนินการโดย"}{" "}
                                  : {item?.approve_name}
                                </Label>
                                <Label xxl={4}>
                                  วันที่ดำเนินการ :{" "}
                                  {item?.approve_date
                                    ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                    : null}
                                </Label>
                              </Row>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={4}>
                                  สถานะ :{" "}
                                  {item?.leave_status === null
                                    ? "รอดำเนินการ"
                                    // "รออนุมัติ"
                                    : item?.leave_status === "3"
                                    ? "อนุญาต"
                                    : item?.leave_status === "5"
                                    ? "อนุมัติ"
                                    : item?.leave_status === "9"
                                    ? "ส่งกลับแก้ไข"
                                    : item?.leave_status === "M"
                                    ? "-"
                                    : item?.leave_status === "6"
                                    ? !arr[idx - 1]?.leave_status ? "ไม่อนุมัติ" : "ไม่อนุญาต"
                                    : "ยกเลิก"}
                                </Label>
                                <Label xxl={4}>
                                  ความเห็น : {item?.reason || "-"}
                                </Label>
                              </Row>
                            </Col>
                          </Row></>
                        );
                      } else if (idx !== 0) {
                        if (arr[idx - 1]?.leave_status === "5") {
                          return (
                            <>
                              <h4 className="mt-3 ms-2">ประวัติการขอยกเลิก</h4>
                              <Row
                                key={idx}
                                className="mt-2 pb-1"
                                style={{ borderBottom: "1px solid lightgray" }}
                              >
                                <Col>
                                  <Row className="d-flex justify-content-center">
                                    <Label xxl={6}>
                                      {item?.leave_status === null
                                        ? "รอดำเนินการโดย"
                                        : "ดำเนินการโดย"}
                                      : {item?.approve_name}
                                    </Label>
                                    <Label xxl={4}>
                                      วันที่ดำเนินการ :{" "}
                                      {item?.approve_date
                                        ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                        : null}
                                    </Label>
                                  </Row>
                                  <Row className="d-flex justify-content-center">
                                    <Label xxl={4}>
                                      สถานะ :{" "}
                                      {item?.leave_status === null
                                        ? arr[idx - 1]?.leave_status === "3"
                                          ? "รอดำเนินการ"
                                          // "รออนุมัติ"
                                          : arr[idx - 1]?.leave_status === "5"
                                          ? "รอดำเนินการ"
                                          // "รออนุญาตยกเลิก"
                                          : arr[idx - 1]?.leave_status === "B"
                                          ? "รอดำเนินการ"
                                          : arr[idx - 1]?.leave_status === "M"
                                          ? "-"
                                          // "รออนุมัติยกเลิก"
                                          : "ยกเลิก"
                                        : item?.leave_status === "3"
                                        ? "อนุญาตยกเลิก"
                                        : item?.leave_status === "5"
                                        ? arr[idx - 1]?.leave_status === "5" || arr[idx - 1]?.leave_status === "B"
                                        ? "ไม่อนุมัติยกเลิก" : "อนุมัติ"
                                        : item?.leave_status === "6"
                                        ? "ไม่อนุมัติ"
                                        : item?.leave_status === "B"
                                        ? "อนุญาตยกเลิก"
                                        : item?.leave_status === "A"
                                        ? "อนุมัติยกเลิก"
                                        : item?.leave_status === "M"
                                        ? "-"
                                        : null}
                                    </Label>
                                    <Label xxl={4}>
                                      ความเห็น : {item?.reason || "-"}
                                    </Label>
                                  </Row>
                                </Col>
                              </Row>
                            </>
                          );
                        }
                        return (
                          <Row
                            key={idx}
                            className="mt-2 pb-1"
                            style={{ borderBottom: "1px solid lightgray" }}
                          >
                            <Col>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={6}>
                                  {item?.leave_status === null
                                    ? "รอดำเนินการโดย"
                                    : "ดำเนินการโดย"}
                                  : {item?.approve_name}
                                </Label>
                                <Label xxl={4}>
                                  วันที่ดำเนินการ :{" "}
                                  {item?.approve_date
                                    ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                    : null}
                                </Label>
                              </Row>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={4}>
                                  สถานะ :{" "}
                                  {item?.leave_status === null
                                    ? arr[idx - 1]?.leave_status === "5"
                                      ? "รอดำเนินการ"
                                      // "รออนุมัติยกเลิก"
                                      : arr[idx - 1]?.leave_status === "7"
                                      ? "รอดำเนินการ"
                                      : arr[idx - 1]?.leave_status === "M"
                                      ? "-"
                                      : arr[idx - 1]?.leave_status === "3"
                                      ? "รอดำเนินการ"
                                      // "รออนุมัติยกเลิก"
                                      : "ยกเลิก"
                                    : item?.leave_status === "5"
                                    ? arr[idx - 1]?.leave_status === "5" || arr[idx - 1]?.leave_status === "B"
                                      ? "ไม่อนุมัติยกเลิก" : "อนุมัติ"
                                    : item?.leave_status === "6"
                                    ? "ไม่อนุมัติ"
                                    : item?.leave_status === "B"
                                    ? "อนุญาตยกเลิก"
                                    : item?.leave_status === "A"
                                    ? "อนุมัติยกเลิก"
                                    : item?.leave_status === "M"
                                    ? "-"
                                    : null}
                                </Label>
                                <Label xxl={4}>
                                  ความเห็น : {item?.reason || "-"}
                                </Label>
                              </Row>
                            </Col>
                          </Row>
                        );
                      }
                    } else {
                      if (idx === 0) {
                        return (
                          <><h4>ประวัติการอนุมัติ</h4>
                          <Row
                            key={idx}
                            className="mt-2 pb-1"
                            style={{ borderBottom: "1px solid lightgray" }}
                          >
                            <Col>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={6}>
                                  {item?.leave_status === null
                                    ? "รอดำเนินการโดย"
                                    : "ดำเนินการโดย"}{" "}
                                  : {item?.approve_name}
                                </Label>
                                <Label xxl={4}>
                                  วันที่ดำเนินการ :{" "}
                                  {item?.approve_date
                                    ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                    : null}
                                </Label>
                              </Row>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={4}>
                                  สถานะ :{" "}
                                  {item?.leave_status === null
                                    ? "รอดำเนินการ"
                                    // "รออนุญาต"
                                    : item?.leave_status === "3"
                                    ? "อนุญาต"
                                    : item?.leave_status === "6"
                                    ? !arr[idx - 1]?.leave_status ? "ไม่อนุมัติ" : "ไม่อนุญาต"
                                    : item?.leave_status === "9"
                                    ? "ส่งกลับแก้ไข"
                                    : item?.leave_status === "M"
                                    ? "-"
                                    : "ยกเลิก"}
                                </Label>
                                <Label xxl={4}>
                                  ความเห็น : {item?.reason || "-"}
                                </Label>
                              </Row>
                            </Col>
                          </Row></>
                        );
                      } else if (idx !== 0) {
                        if (arr[idx - 1]?.leave_status === "5") {
                          return (
                            <>
                              <h4 className="mt-3 ms-2">ประวัติการขอยกเลิก</h4>
                              <Row
                                key={idx}
                                className="mt-2 pb-1"
                                style={{ borderBottom: "1px solid lightgray" }}
                              >
                                <Col>
                                  <Row className="d-flex justify-content-center">
                                    <Label xxl={6}>
                                      {item?.leave_status === null
                                        ? "รอดำเนินการโดย"
                                        : "ดำเนินการโดย"}
                                      : {item?.approve_name}
                                    </Label>
                                    <Label xxl={4}>
                                      วันที่ดำเนินการ :{" "}
                                      {item?.approve_date
                                        ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                        : null}
                                    </Label>
                                  </Row>
                                  <Row className="d-flex justify-content-center">
                                    <Label xxl={4}>
                                      สถานะ :{" "}
                                      {item?.leave_status === null
                                        ? arr[idx - 1]?.leave_status === "3"
                                          ? "รอดำเนินการ"
                                          // "รออนุมัติ"
                                          : arr[idx - 1]?.leave_status === "5"
                                          ? "รอดำเนินการ"
                                          // "รออนุญาตยกเลิก"
                                          : arr[idx - 1]?.leave_status === "B"
                                          ? "รอดำเนินการ"
                                          : arr[idx - 1]?.leave_status === "M"
                                          ? "-"
                                          // "รออนุมัติยกเลิก"
                                          : "ยกเลิก"
                                        : item?.leave_status === "3"
                                        ? "อนุญาตยกเลิก"
                                        : item?.leave_status === "5"
                                        ? arr[idx - 1]?.leave_status === "5" || arr[idx - 1]?.leave_status === "B"
                                        ? "ไม่อนุมัติยกเลิก" : "อนุมัติ"
                                        : item?.leave_status === "6"
                                        ? "ไม่อนุมัติ"
                                        : item?.leave_status === "B"
                                        ? "อนุญาตยกเลิก"
                                        : item?.leave_status === "A"
                                        ? "อนุมัติยกเลิก"
                                        : item?.leave_status === "M"
                                        ? "-"
                                        : null}
                                    </Label>
                                    <Label xxl={4}>
                                      ความเห็น : {item?.reason || "-"}
                                    </Label>
                                  </Row>
                                </Col>
                              </Row>
                            </>
                          );
                        }
                        return (
                          <Row
                            key={idx}
                            className="mt-2 pb-1"
                            style={{ borderBottom: "1px solid lightgray" }}
                          >
                            <Col>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={6}>
                                  {item?.leave_status === null
                                    ? "รอดำเนินการโดย"
                                    : "ดำเนินการโดย"}
                                  : {item?.approve_name}
                                </Label>
                                <Label xxl={4}>
                                  วันที่ดำเนินการ :{" "}
                                  {item?.approve_date
                                    ? getDateTime('DD MMM BBBB',item?.approve_date, true)
                                    : null}
                                </Label>
                              </Row>
                              <Row className="d-flex justify-content-center">
                                <Label xxl={4}>
                                  สถานะ :{" "}
                                  {item?.leave_status === null
                                    ? arr[idx - 1]?.leave_status === "3"
                                      ? "รอดำเนินการ"
                                      // "รออนุมัติ"
                                      : arr[idx - 1]?.leave_status === "5"
                                      ? "รอดำเนินการ"
                                      // "รออนุญาตยกเลิก"
                                      : arr[idx - 1]?.leave_status === "9"
                                      ? "รอดำเนินการ"
                                      : arr[idx - 1]?.leave_status === "B"
                                      ? "รอดำเนินการ"
                                      : arr[idx - 1]?.leave_status === "M"
                                      ? "-"
                                      // "รออนุมัติยกเลิก"
                                      : "ยกเลิก"
                                    : item?.leave_status === "3"
                                    ? "อนุญาต"
                                    : item?.leave_status === "5"
                                        ? arr[idx - 1]?.leave_status === "5" || arr[idx - 1]?.leave_status === "B"
                                        ? "ไม่อนุมัติยกเลิก" : "อนุมัติ"
                                    : item?.leave_status === "6"
                                    ? "ไม่อนุมัติ"
                                    : item?.leave_status === "9"
                                    ? "ส่งกลับแก้ไข"
                                    : item?.leave_status === "B"
                                    ? "อนุญาตยกเลิก"
                                    : item?.leave_status === "A"
                                    ? "อนุมัติยกเลิก"
                                    : item?.leave_status === "M"
                                    ? "-"
                                    : null}
                                </Label>
                                <Label xxl={4}>
                                  ความเห็น : {item?.reason || "-"}
                                </Label>
                              </Row>
                            </Col>
                          </Row>
                        );
                      }
                    }
                  }
                })
    )
  }
    
}

export default ApproveHistory